import { atom } from 'jotai';


export const selectedRecord=atom(null);
export const retirementQuantity=atom(null);
export const pickedTable=atom(null);
export const companyJobsAtom=atom(null);
export const accessTokenAtom=atom(null);
export const groupAssociation=atom(null);
export const menuDisabledAtom=atom(false);

